import React, { useEffect } from 'react'
import MainContainer from '../Components/Elements/MainContainer'
import Text from '../Components/Elements/Text'
import logo from '../images/RH-Vectorised-Logo.svg'
import { Formik } from 'formik'
import { LandingPageFormValues } from '../Models/LandingPageFormValues'
import { useStore } from '../Stores/store'
import { Helmet } from 'react-helmet'
import { useNavigate } from "react-router";
import { observer } from 'mobx-react-lite'

interface Props {
    useHelm?: boolean;
}

const LandingPage = observer(({ useHelm = false } : Props) => {
    const { generalStore } = useStore();
    const { validateAccessCode, loginFormLoading, token, setShowFooterAndNav } = generalStore;
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            navigate('/app');
        }
        else {
            setShowFooterAndNav(false);
        }
    });

    const formVals : LandingPageFormValues = {
        code: ''
    }

    const handleSubmit = async (values : LandingPageFormValues) => {
        const result = await validateAccessCode(values.code);
        if (result) {
            navigate('/app');
        }
    }

    return (
        <MainContainer>
            {
                useHelm && (
                    <Helmet>
                        <meta charSet="utf-8" />
                        <title>H&R Wedding</title>
                    </Helmet>
                )
            }
            <div className='w-9/10 sm:w-4/5 flex justify-center flex-col mx-auto'>
                <div className="mx-auto w-100">
                    <img src={logo} alt="logo" width="250" className="p-5" />
                </div>
                <Text>Please enter the code provided on your wedding invitation.</Text>
                <Formik
                initialValues={formVals}
                onSubmit={(values) => handleSubmit(values)}
                enableReinitialize
                >
                    {({handleSubmit, handleChange, values}) => (
                    <form onSubmit={handleSubmit} className="flex flex-col items-center py-5">
                        <label htmlFor="code" className="py-3">Code<span className="text-red-600">*</span></label>
                        <input type="text" name="code" id="code" value={values.code} onChange={handleChange} className="w-9/10 sm:w-1/2 px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition duration-200 font-lora" />
                        <input type="submit" value={loginFormLoading ? "Loading" : "Submit"} disabled={loginFormLoading} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded my-6 sm:w-1/5 font-lora" />
                    </form>)}
                </Formik>
            </div>
        </MainContainer>
    )
})

export default LandingPage